export const enStrings = {
    accountsBot: "Accounts",
    accountsActual: "Accounts (actual)",
    analytics: "Analytics",
    artist: "Artist",
    by: "By: ",
    country: "Country",
    days: "days",
    filter: "Filter",
    filterBy: "Filter by...",
    hideFilters: "Hide filters",
    hours: "hours",
    h:"h",
    infoAnalytics: "The actual streams are synchronized daily, so these reports may not reflect your figures at the exact point of time.",
    login: "LOGIN",
    logout: "Log out",
    minutes: "minutes",
    m:"m",
    ok: "OK",
    period: "Period: ",
    streamsBot: "Streams",
    streamsActual: "Streams (actual)",
    seconds: "seconds",
    s:"s",
    sBotsAnalytics: "Analytics",
    startTyping: "Start typing",
    service: "Service",
    totalAccounts: "Total accounts",
    totalStreams: "Total streams",
    totalUniqueListeners: "Total unique listens",
    uniqueListenersBot: "Unique listens",
    uniqueListenersActual: "Unique listens (actual)",
    uniqueListeners: "Unique listens",
    mobileUniqueListeners: "Mobile unique listens",
    uniqueListensExplanation: "* Unique listens = number of unique track plays by accounts in the time period. If an account plays the same track more times in the time period, it still counts as one unique listen.",
    view: "View: ",
    welcomeAnalytics: "Here you will find detailed stream statistics. ",
    serviceFilter: "Service:",
    summaryReport: "Summary report",
    dashboard: "Dashboard",
    dateFrom: "Date from:",
    dateTo: "Date to:",
    date: "Date: ",
    startDate: "Start date",
    numberOfListeningAccounts: "Number of listening accounts",
    accountGroupName: "Account group name",
    accountGroupId: "Account group ID",
    dateCreated: "Date created",
    byServiceHeader: "Summary Report By Service Type",
    byAccountGroupHeader: "Summary Report For Account Groups",
    areaPlotHeader: "Summary Report By Service Type - Area Plot",
    barChartHeader: "Summary Report For Account Groups - Bar Chart",
    ours: "Label Artists",
    notOurs: "Others",
    total: "Total",
    totalAccountsInGroup: "Total accounts in group",
    totalSongs: "Total songs played",
    songsBot: "Songs played",
    importedSongs: "Imported songs",
    "title": "Title",
    "album": "Album",
    "URL": "URL",
    "probability": "Probability",
    "probabilityBoosted": "Boosted",
    "probabilityMedium": "Medium",
    "probabilityLow": "Low",
    "group": "Group",
    "dateImported": "Date imported",
    "scrapedDataHeader": "Scraped Data Summary",
    "scrapedData": "Scraped data",
    "totalForEveryArtist": "Total streams and unique listeners for every artist",
    "totalForEveryArtistByPlatform": "Total browser and mobile streams for every artist",
    "totalForArtist": "Total streams and unique listeners for: ",
    "totalForArtistByPlatform": "Total browser and mobile streams for: ",
    "dateColumn": "Date",
    totalStreamsForEveryArtist: "Scraped streams",
    totalUniqueListenersForEveryArtist: "Scraped unique listeners",
    comparisonTable: "Inteligenta vs Deezer Comparison",
    difference: "Difference",
    "scrapedStreams": "Scraped streams",
    "scrapedUniqueListens": "Scraped unique listens",
    "browserViews": "Streams on browser",
    "mobileViews": "Streams on mobile",
    "botStreamsByPlatform": "Browser and mobile streams",
    "botStreamsByPlatformForArtists": "Browser and mobile streams for selected artists",
    "mobileStreams": "Mobile streams",
    "browserStreams": "Browser streams",
    "totalForEveryArtistByOffer": "Total ad-supported and subscriber streams for every artist",
    "totalForArtistByOffer": "Total ad-supported and subscriber streams for: ",
    "adSupportedViews": "Ad-supported streams",
    "subscriberViews": "Subscriber streams",
    "streamingContextsTable": "Deezer streaming contexts",
    "contextPlaylist": "In playlists",
    "contextAlbum": "Album pages",
    "contextArtistPage": "The artist page",
    "contextLovedTracks": "Users' favourite tracks",
    "contextMixFlow": "Flow or a mix",
    "contextOther": "Partner apps",
    "streamsPerCountryTable": "Deezer streams per country"
};
